<template>
  <div class="extraction-field-group">
    <extraction-field-group-header v-if="headerTitle">
      {{ headerTitle }}
    </extraction-field-group-header>
    <v-expansion-panels
      v-model="model"
      accordion
      multiple
      class="flex-column"
    >
      <div
        v-for="(field, i) in dataFields"
        :key="field.id"
        class="flex-grow-1"
      >
        <extraction-field
          :report-id="report.id"
          :field="field"
          :disabled="disabled"
          :value="getFieldValue(field)"
          @input="onFieldValueChange(field, $event)"
        />
        <v-divider v-if="i < dataFields.length - 1" class="divider" />
      </div>
    </v-expansion-panels>
  </div>
</template>

<script>
import ExtractionFieldGroupHeader from './ExtractionFieldGroupHeader';
import ExtractionField from './ExtractionField';
import {
  DataExtractionFieldBase,
  DataExtractionFieldHeader,
  DataExtractionReport,
  createDataExtractionValue,
} from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'ExtractionFieldGroup',
  components: { ExtractionFieldGroupHeader, ExtractionField },
  props: {
    report: {
      type: DataExtractionReport,
      required: true,
    },
    headerField: {
      type: DataExtractionFieldHeader,
      required: false,
      default: null,
    },
    dataFields: {
      type: Array,
      required: true,
      validator: (field) =>
        typeHelpers.isArrayOfType(field, DataExtractionFieldBase),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    collapseAll: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  data: () => ({ model: [], changeKey: 0 }),
  computed: {
    reportValues() {
      return this.report?.values;
    },
    headerTitle() {
      return this.headerField?.title;
    },
  },
  watch: {
    report() {
      this.changeKey++;
    },
  },
  created() {
    if (!this.collapseAll) {
      this.model = this.dataFields.map((_, i) => i);
    }
  },
  methods: {
    getFieldValue(field) {
      return (
        this.reportValues?.find(
          (value) => value.field.id === field.id
        ) ?? null
      );
    },
    onFieldValueChange(field, newFields) {
      const existingValue = this.getFieldValue(field);

      const definedProps = (obj) =>
        Object.fromEntries(
          Object.entries(obj).filter(([, v]) => v !== undefined)
        );
      let newValueProps = {
        field,
        ...definedProps(existingValue ?? {}),
        ...definedProps(newFields),
      };
      const newValue = createDataExtractionValue(newValueProps);
      this.$emit('input', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.divider {
  border-color: map-get($grey, 'lighten-3') !important;
}
</style>
